import styles from './EventPeriod.module.css'

type Props = {
  startDate: string
  endDate: string
  className?: string
}

/**
 * v2キャンペーンの開催期間を表示するコンポーネント
 * */
export function EventPeriod({ startDate, endDate, className }: Props) {
  return (
    <div className={`${styles.container} ${className ?? ''}`}>
      <p className={styles.text}>
        開催期間：{startDate}〜{endDate}
      </p>
    </div>
  )
}
